import { useTranslation } from 'react-i18next';
import ErrorModal from '@components/dialogs/ErrorModal.component.jsx';
import EventLayout from '@layouts/Event.layout.jsx';

export default function NoTicketsError({ showPreloader, onButtonClick }) {
  const { t } = useTranslation();

  return (
    <EventLayout showPreloader={showPreloader}>
      <ErrorModal
        header={t('printer.header.unavailable')}
        description={t('printer.subHeader.unavailable')}
        buttonText={t('printer.emptyTicketListButton')}
        onButtonClick={onButtonClick}
      />
    </EventLayout>
  );
}
